(function () {
    'use strict';

    angular
        .module('appback')
        .controller('WorkflowEjecucionesController', WorkflowEjecucionesController)

    WorkflowEjecucionesController.$inject = ["$scope", "$interval", "WorkflowEjecucionesService"];

    /**
     * Vista "Ejecuciones de workflow" (backend/views/workflow-ejecuciones/index.php):
     * tablero kanban con una columna por estado (más la de programaciones
     * en espera, a la izquierda); al elegir una tarjeta, su recorrido paso a
     * paso se abre en un offcanvas. Mientras quede alguna
     * ejecución en curso se refresca sola cada AUTO_REFRESH_MS, conservando
     * cuántas se ven de cada columna, la ejecución elegida y las respuestas
     * desplegadas.
     */
    function WorkflowEjecucionesController($scope, $interval, WorkflowEjecucionesService) {
        var we = this;
        var AUTO_REFRESH_MS = 20000;
        // Ticks entre refrescos cuando no hay ninguna ejecución en curso.
        var TICKS_SIN_CURSO = 3;
        var POR_COLUMNA = 20;
        var LIMITE_MAX = 200;
        var ESTADOS = ['en_curso', 'completada', 'interrumpida', 'cancelada'];

        we.loading = false;
        we.error = false;
        we.cargado = false;
        we.resumen = { total: 0, en_curso: 0, completada: 0, interrumpida: 0, cancelada: 0 };
        we.columnas = {};
        // Programaciones que ahora mismo no están corriendo y cuándo les toca.
        we.programadas = [];
        ESTADOS.forEach(function (estado) {
            we.columnas[estado] = { items: [], total: 0, limite: POR_COLUMNA };
        });
        we.selected = null;

        // Respuestas de Hermes desplegadas, por "ejecución:paso" (un mismo
        // step se comparte entre todas las ejecuciones del mismo workflow).
        var respuestasAbiertas = {};
        var offcanvas = null;

        we.iconoEstado = { en_curso: 'pending', completada: 'task_alt', interrumpida: 'error', cancelada: 'cancel' };
        we.iconoPaso = { completado: 'check', omitido: 'redo', pendiente: 'hourglass_top', sin_ejecutar: 'more_horiz', cancelado: 'cancel' };
        we.badgeEstado = { en_curso: 'badge-soft', completada: 'badge-trend-positive', interrumpida: 'badge-trend-negative', cancelada: 'badge-trend-negative' };
        we.badgePaso = { completado: 'badge-trend-positive', omitido: 'wf-badge-omitido', pendiente: 'badge-soft', sin_ejecutar: 'wf-badge-sin_ejecutar', cancelado: 'badge-trend-negative' };

        we.init = function () {
            we.cargar();

            var ticks = 0;
            var refresco = $interval(function () {
                ticks++;
                if (we.loading) {
                    return;
                }

                // Con algo en curso, se refresca en cada tick; si solo hay
                // programaciones esperando, basta con poner al día su cuenta
                // atrás de vez en cuando.
                if (we.resumen.en_curso > 0 || (we.programadas.length && ticks % TICKS_SIN_CURSO === 0)) {
                    we.cargar(true);
                }
            }, AUTO_REFRESH_MS);

            $scope.$on('$destroy', function () {
                $interval.cancel(refresco);
                if (offcanvas) {
                    offcanvas.hide();
                }
            });
        };

        we.cargar = function (silencioso) {
            var params = {};
            ESTADOS.forEach(function (estado) {
                params[estado] = we.columnas[estado].limite;
            });

            we.loading = true;

            return WorkflowEjecucionesService.Listado(params, silencioso).then(function (data) {
                we.error = false;
                we.cargado = true;
                we.resumen = data.resumen;
                we.programadas = data.programadas || [];
                ESTADOS.forEach(function (estado) {
                    var columna = data.columnas[estado] || { items: [], total: 0 };
                    we.columnas[estado].items = columna.items;
                    we.columnas[estado].total = columna.total;
                });

                // La elegida puede haber cambiado de columna; si ya no se
                // devuelve, el offcanvas sigue mostrando la versión anterior.
                if (we.selected) {
                    we.selected = buscarPorId(we.selected.id) || we.selected;
                }
            }, function () {
                we.error = true;
            }).finally(function () {
                we.loading = false;
            });
        };

        we.hayMas = function (estado) {
            var columna = we.columnas[estado];
            return columna.items.length < columna.total && columna.limite < LIMITE_MAX;
        };

        we.verMas = function (estado) {
            var columna = we.columnas[estado];
            columna.limite = Math.min(LIMITE_MAX, columna.limite + POR_COLUMNA);
            we.cargar();
        };

        we.seleccionar = function (ejecucion) {
            we.selected = ejecucion;
            getOffcanvas().show();
        };

        we.respuestaAbierta = function (paso) {
            return !!respuestasAbiertas[claveRespuesta(paso)];
        };

        we.toggleRespuesta = function (paso) {
            var clave = claveRespuesta(paso);
            respuestasAbiertas[clave] = !respuestasAbiertas[clave];
        };

        function claveRespuesta(paso) {
            return (we.selected ? we.selected.id : '') + ':' + paso.id;
        }

        function buscarPorId(id) {
            for (var i = 0; i < ESTADOS.length; i++) {
                var items = we.columnas[ESTADOS[i]].items;
                for (var j = 0; j < items.length; j++) {
                    if (items[j].id === id) {
                        return items[j];
                    }
                }
            }

            return null;
        }

        function getOffcanvas() {
            if (!offcanvas) {
                var elemento = document.getElementById('workflowEjecucionOffcanvas');
                offcanvas = new bootstrap.Offcanvas(elemento);
                elemento.addEventListener('hidden.bs.offcanvas', function () {
                    $scope.$evalAsync(function () {
                        we.selected = null;
                    });
                });
            }

            return offcanvas;
        }
    }
})();
